import Vue from 'vue'
import API from '../utils/api'
import env from '../../../config/prod.env.js'

const state = {
  categoriescon: []
}

const mutations = {  
  SET_CATEGORIES_CON (state, payload) {
    state.categoriescon = payload
  },
  API_FAILURE (state, payload) {
    throw {error: true, payload: payload.body}
  } 
}

const actions = {
  categoriesconList: (context, id) => {
    return Vue.http.get(`${env.API}/api/category-con`)    
      .then((response) => {        
        context.commit('SET_CATEGORIES_CON', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  }
}

const getters = {
  getCategoriescon: (state) => state.categoriescon
}

export const categorycon = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/categorycon.js